var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeuroDiversityLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406 37c-8-6-38-29-82-27l-1-5 1 5c-38 2-63 20-72 27-2 2-5 1-7-1s-1-5 1-7c9-7 37-27 77-29 48-2 81 22 89 29 2 2 3 5 1 7s-5 3-7 1z",
    fill: "url(#paint0_linear_49_359)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 83V44h6l1 4c1-1 2-2 3-2 2-1 5-2 8-2 9 0 16 6 16 16v23h-8V60c0-5-4-9-9-9s-9 4-9 9v23H0zM69 72h8c-3 6-8 11-17 11-10 0-18-8-18-20 0-11 8-19 18-19 9 0 18 8 18 19 0 1-1 2-1 3v1H50c0 5 4 9 10 9 5 0 7-3 9-4zM50 60h20c-1-5-4-9-10-9s-9 4-10 9zM86 66V44h7v22c0 6 5 10 9 10 5 0 10-4 10-10V44h8v39h-6l-2-4-2 2c-2 1-5 2-9 2-8 0-15-7-15-17zM130 83V44h5l2 4c1-1 2-2 3-2 1-1 4-2 7-2h2v8c-1-1-2-1-2-1-5 0-10 5-10 10v22h-7zM173 76c5 0 10-5 10-13 0-7-5-12-10-12-6 0-11 5-11 12 0 8 5 13 11 13zm0 7c-11 0-19-8-19-20 0-11 8-19 19-19 10 0 18 8 18 19 0 12-8 20-18 20zM228 83l-1-4c-1 1-2 1-3 2-2 1-5 2-9 2-10 0-18-8-18-20 0-11 8-19 18-19 4 0 7 1 8 2 1 0 2 1 3 2V28h8v55h-6zm-12-7c6 0 11-5 11-13 0-7-5-12-11-12s-11 5-11 12c0 8 5 13 11 13zM245 83V44h7v39h-7zm3-55c3 0 5 3 5 5 0 3-2 5-5 5-2 0-4-2-4-5 0-2 2-5 4-5zM274 83l-16-39h8l11 28 11-28h8l-15 39h-7zM327 72h8c-3 6-8 11-17 11-10 0-18-8-18-20 0-11 8-19 18-19s18 8 18 19v3l-1 1h-27c0 5 5 9 10 9s7-3 9-4zm-19-12h20c0-5-4-9-10-9-5 0-9 4-10 9zM344 83V44h6l1 4c1-1 2-2 3-2 1-1 4-2 7-2h3v8h-1c-1-1-1-1-2-1-5 0-9 5-9 10v22h-8zM368 70h8c0 4 3 6 7 6 5 0 7-2 7-5 0-7-21-2-21-16 0-6 5-11 13-11 9 0 14 4 15 12h-8c-1-3-3-5-7-5-3 0-6 2-6 4 0 7 21 2 21 16 0 7-5 12-14 12-10 0-14-4-15-13zM405 83V44h8v39h-8zm4-55c3 0 5 3 5 5 0 3-2 5-5 5s-5-2-5-5c0-2 2-5 5-5zM424 83V51h-4v-7h4v-3c0-8 6-13 12-13h4l1 1v7h-1c-1 0-1-1-2-1-3 0-6 3-6 6v3h9v7h-9v32h-8zM450 97v-7c4 0 6-2 7-5l1-4-15-37h8l11 28 11-28h8l-16 41c-4 9-7 12-13 12h-2z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_359",
    x1: 314.02,
    y1: 36.5608,
    x2: 314.995,
    y2: -5.80555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205239,
    stopColor: "#0686FF",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451829,
    stopColor: "#0686FF",
    stopOpacity: 0.672409
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68036,
    stopColor: "#0686FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_359"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(244)",
    d: "M0 0h170v38H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuroDiversityLogo);
export default __webpack_public_path__ + "static/media/NeuroDiversityLogo.101c3cc3303e01da72566c9fdc2aa68b.svg";
export { ForwardRef as ReactComponent };